import styled from 'styled-components'

import { helpers } from '../../../styles/theme'

export const Aside = styled.div`
	color: ${helpers.color.input.placeholder};
	white-space: pre;
	user-select: none;
	pointer-events: none;
	padding: 2px 6px 0 0;
`
